module.exports = __webpack_public_path__ + "img/user-right-02.4a4e55df.svg";